// @flow
import React, { type Node } from 'react';

import styles from './left-bar-content.module.scss';;


type Props = {
  children: Node,
}

const LeftBarContent = ({ children }: Props) => (
  <div className={styles.root}>
    {children}
  </div>
);

export default LeftBarContent;
